// Discovery has a single source now (Forager/AdeptID). Kept as a named constant
// so the analytics field and the feedback storage key stay stable across the
// retirement of the job-seekers-backed tab.
export const DISCOVERY_SOURCE = 'forager';
